// extracted by mini-css-extract-plugin
export default {"label":"Label_label__Ahcbt","required":"Label_required__YO1Yi"};